import api from "./utils";

const getMastodonResults = async (params) => {
  return await api.get(`/mastodon/crawl/results`, { params }).then((r) => r.data);
};

const crawlMastodonHashtag = async (data) => {
  return await api.post("/mastodon/crawl/start", data).then((r) => r.data);
};

const getMastodonTasks = async () => {
  return await api.get("/mastodon/crawl/tasks").then((r) => r.data);
};

const killMastodonTask = async (task) => {
  return await api.post("/mastodon/crawl/stop", task).then((r) => r.data);
};

const deleteMastodonTask = async (task) => {
  return await api.delete(
    `/mastodon/crawl/tasks/delete/${encodeURIComponent(task.hashtag_id)}`
  );
};

export {
  getMastodonResults,
  crawlMastodonHashtag,
  getMastodonTasks,
  killMastodonTask,
  deleteMastodonTask,
};
